import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLang } from "@/context/LangContext";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
  const { t } = useLang();
  const [testimonials, setTestimonials] = useState([]);
  useEffect(() => { axios.get(`${API}/content/testimonials`).then(r => setTestimonials(r.data)).catch(() => {}); }, []);
  if (!testimonials.length) return null;
  return (
    <section className="relative py-16 md:py-32 bg-[#0a0a0a]" data-testid="testimonials-section">
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-[#E60000]/5 rounded-full blur-[200px]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 relative z-10">
        <div className="mb-10 md:mb-16 text-center">
          <span className="text-[#E60000] text-xs sm:text-sm uppercase tracking-[0.3em] font-medium font-body">{t.testimonials.section_tag}</span>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl tracking-tight font-bold uppercase text-white mt-3" data-testid="testimonials-title">
            {t.testimonials.title} <span className="text-[#E60000]">{t.testimonials.title_accent}</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
          {testimonials.map((item, i) => (
            <motion.div key={item.id || i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.12, duration: 0.5 }} className="p-5 sm:p-8 border border-white/5 hover:border-[#E60000]/30 bg-[#121212]/50 transition-all duration-500 group" data-testid={`testimonial-${i}`}>
              <Quote className="w-8 h-8 text-[#E60000]/30 mb-4" />
              <p className="font-body text-sm text-white/70 leading-relaxed mb-6 italic">"{item.text}"</p>
              <div className="flex items-center gap-1 mb-3">{[...Array(item.rating || 5)].map((_, j) => (<Star key={j} className="w-3.5 h-3.5 fill-[#E60000] text-[#E60000]" />))}</div>
              <p className="font-heading text-sm font-bold uppercase text-white tracking-tight">{item.name}</p>
              <p className="font-body text-xs text-[#A3A3A3]">{item.role_label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
